import { Store } from '@reduxjs/toolkit';
import { History } from 'history';

export const STORE_TOKEN = 'STORE';
export type BFStore = Store;
export const HISTORY_TOKEN = 'HISTORY';
export type BFHistory = History;
